var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.isLeft ? "floL" : "floR" },
    [
      _c(
        "p",
        {
          staticClass: "fntH6 fntL bold marTML marBM",
          staticStyle: { color: "#2c2c2c", width: "49%" },
          style: _vm.isLeft ? { width: "49%" } : null
        },
        [_vm._v(_vm._s(_vm.getFullTextByType(_vm.participant)))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBM",
          class: _vm.isLeft ? "pf23-inFo-L" : "pf23-inFo-R"
        },
        [
          _c("p", { staticClass: "fntP", class: { moOnly: !_vm.isLeft } }, [
            _vm._v("참여여부 "),
            _c("span", { staticClass: "ico-must-astar" })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "amway-theme", staticStyle: { width: "55%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                },
                [
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "Y",
                          name: "attendance-radio-" + _vm.seq,
                          disabled: !_vm.infoAvailable
                        },
                        domProps: {
                          checked: _vm.participant.attendance_yn === "Y"
                        },
                        on: { change: _vm.selectAttendance }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("참여")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "N",
                          name: "attendance-radio-" + _vm.seq,
                          disabled: !_vm.infoAvailable
                        },
                        domProps: {
                          checked: _vm.participant.attendance_yn === "N"
                        },
                        on: { change: _vm.selectAttendance }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("불참")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM pf23-inFo-common pf23-lineBtm",
          class: _vm.isLeft ? "pf23-inFo-L" : "pf23-inFo-R"
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              class: { moOnly: !_vm.isLeft },
              attrs: { for: "NCAcmi_name-" + _vm.seq }
            },
            [_vm._v("이름 "), _c("span", { staticClass: "ico-must-astar" })]
          ),
          _vm._v(" "),
          _c("input", {
            attrs: {
              type: "text",
              size: "50",
              maxlength: "50",
              id: "NCAcmi_name-" + _vm.seq,
              name: "NCAcmi_name" + _vm.seq,
              disabled:
                _vm.disabledByType ||
                _vm.disabledByAttendance ||
                !_vm.infoAvailable
            },
            domProps: { value: _vm.participant.name },
            on: {
              input: function($event) {
                return _vm.inputName(_vm.seq, $event.target.value)
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM pf23-lineBtm",
          class: _vm.isLeft
            ? "pf23-inFo-L pf23-inFo-common"
            : "pf23-inFo-blank01"
        },
        [
          _vm.isLeft
            ? [
                _c(
                  "label",
                  {
                    staticClass: "fntP",
                    attrs: { for: "NCAcmi_abo" + _vm.seq }
                  },
                  [_vm._v("ABO번호")]
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    disabled: "",
                    id: "NCAcmi_abo" + _vm.seq,
                    name: "NCAcmi_abo" + _vm.seq
                  },
                  domProps: { value: _vm.participant.abo_uid }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_mobile-" + _vm.seq }
              },
              [
                _vm._v("휴대폰번호 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v("\n      010 -\n      "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.participant.questions["Q200"].hasError &&
                _vm.participant.questions["Q200"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "8",
                placeholder: "- 없이 입력",
                id: "Q200-" + _vm.seq,
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q200"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputNumberFixWordAnswer(
                    _vm.seq,
                    "Q200",
                    $event.target,
                    8
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [
              _vm.participant.questions["Q200"].hasError &&
              _vm.participant.questions["Q200"].raw_data
                ? [_vm._v("🚫 010 뒤의 숫자 8자리를 입력해주세요.")]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM pf23-lineBtm",
          class: _vm.isLeft ? "pf23-inFo-L" : "pf23-inFo-R"
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              class: { moOnly: !_vm.isLeft },
              attrs: { for: "NCAcmi_domestic-" + _vm.seq }
            },
            [
              _vm._v("내국인여부 "),
              _c("span", { staticClass: "ico-must-astar" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "amway-theme", staticStyle: { width: "55%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                },
                [
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "DOMESTIC",
                          id: "Q201-" + _vm.seq,
                          name: "domestic-radio-" + _vm.seq,
                          disabled:
                            _vm.disabledByAttendance || !_vm.infoAvailable
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q201"].raw_data ===
                            "DOMESTIC"
                        },
                        on: {
                          change: function($event) {
                            _vm.inputRadioDomesticAnswer(
                              "" + _vm.seq,
                              "Q201",
                              "DOMESTIC"
                            )
                            _vm.inputSelectAnswer(
                              "" + _vm.seq,
                              "Q207",
                              null,
                              "대한민국"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("내국인")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "FOREIGNER",
                          name: "domestic-radio-" + _vm.seq,
                          disabled:
                            _vm.disabledByAttendance || !_vm.infoAvailable
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q201"].raw_data ===
                            "FOREIGNER"
                        },
                        on: {
                          change: function($event) {
                            _vm.inputRadioDomesticAnswer(
                              "" + _vm.seq,
                              "Q201",
                              "FOREIGNER"
                            )
                            _vm.inputSelectAnswer(
                              "" + _vm.seq,
                              "Q207",
                              null,
                              ""
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("외국인")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                staticStyle: { width: "45%" },
                attrs: { for: "NCAcmi_personal01-" + _vm.seq }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.participant.questions["Q201"].raw_data == "FOREIGNER"
                      ? "외국인등록번호"
                      : "주민등록번호"
                  )
                ),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("em", { staticClass: "txtR", staticStyle: { width: "55%" } }, [
              _c("input", {
                staticClass: "NCAcmi_num",
                class:
                  _vm.participant.questions["Q202"].hasError &&
                  _vm.participant.questions["Q202"].raw_data
                    ? "check-red"
                    : "",
                staticStyle: { width: "45%" },
                attrs: {
                  type: "text",
                  maxlength: "6",
                  id: "Q202-" + _vm.seq,
                  name: "NCAcmi_personal" + _vm.seq + "-1",
                  disabled:
                    _vm.disabledByAttendance ||
                    !_vm.infoAvailable ||
                    _vm.participant.questions["Q201"].hasError
                },
                domProps: { value: _vm.participant.questions["Q202"].raw_data },
                on: {
                  input: function($event) {
                    return _vm.inputJuminFirstNumber(
                      _vm.seq,
                      "Q202",
                      $event.target,
                      false
                    )
                  }
                }
              }),
              _c(
                "span",
                { staticClass: "disIb txtC", staticStyle: { width: "10%" } },
                [_vm._v("-")]
              ),
              _c("input", {
                staticClass: "NCAcmi_num",
                class:
                  _vm.participant.questions["Q203"].hasError &&
                  _vm.participant.questions["Q203"].raw_data
                    ? "check-red"
                    : "",
                staticStyle: { width: "45%" },
                attrs: {
                  type: "text",
                  maxlength: "7",
                  id: "Q203-" + _vm.seq,
                  name: "NCAcmi_personal" + _vm.seq + "-2",
                  disabled:
                    _vm.disabledByAttendance ||
                    !_vm.infoAvailable ||
                    _vm.participant.questions["Q201"].hasError
                },
                domProps: { value: _vm.participant.questions["Q203"].raw_data },
                on: {
                  input: function($event) {
                    return _vm.inputJuminLastNumber(
                      _vm.seq,
                      "Q203",
                      $event.target,
                      "Q206"
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em",
                height: "21px"
              }
            },
            [
              (_vm.participant.questions["Q202"].hasError ||
                _vm.participant.questions["Q203"].hasError) &&
              (_vm.participant.questions["Q202"].raw_data ||
                _vm.participant.questions["Q203"].raw_data)
                ? [
                    _vm._v(
                      "\n      🚫 " + _vm._s(_vm.juminHasError) + "\n      "
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM pf23-lineBtm",
          class: _vm.isLeft ? "pf23-inFo-L" : "pf23-inFo-R"
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              class: { moOnly: !_vm.isLeft },
              attrs: { for: "NCAcmi_personal01-" + _vm.seq }
            },
            [_vm._v("성별 "), _c("span", { staticClass: "ico-must-astar" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "amway-theme", staticStyle: { width: "55%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                },
                [
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "FEMALE",
                          id: "Q206-" + _vm.seq,
                          name: "-radio-" + _vm.seq,
                          disabled: true
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q206"].raw_data ===
                            "FEMALE"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("여성")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "MALE",
                          name: "sex-radio-" + _vm.seq,
                          disabled: true
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q206"].raw_data ===
                            "MALE"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("남성")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em",
            height: "21px"
          }
        },
        [_vm._v("* 주민/외국인 등록번호에 따라 자동선택됩니다.")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_engname01-" + _vm.seq }
              },
              [
                _vm._v("여권 영문 성 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.participant.questions["Q204"].hasError &&
                _vm.participant.questions["Q204"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "30",
                placeholder: "여권 영문 성",
                id: "Q204-" + _vm.seq,
                name: "NCAcmi_engname01" + _vm.seq + "-1",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q204"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputEngAnswer(_vm.seq, "Q204", $event.target)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [
              _vm.participant.questions["Q204"].hasError &&
              _vm.participant.questions["Q204"].raw_data
                ? [_vm._v("🚫 2자 이상 영문으로 입력해주세요.")]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_engname02-" + _vm.seq }
              },
              [
                _vm._v("여권 영문 이름 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.participant.questions["Q205"].hasError &&
                _vm.participant.questions["Q205"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "30",
                placeholder: "여권 영문 이름",
                id: "Q205-" + _vm.seq,
                name: "NCAcmi_engname02" + _vm.seq + "-1",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q205"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputEngAnswer(_vm.seq, "Q205", $event.target)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [
              _vm.participant.questions["Q205"].hasError &&
              _vm.participant.questions["Q205"].raw_data
                ? [_vm._v("🚫 2자 이상 영문으로 입력해주세요.")]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_personal01-" + _vm.seq }
              },
              [_vm._v("국가 "), _c("span", { staticClass: "ico-must-astar" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pf23-inFo-select pf23-country" }, [
              _c(
                "select",
                {
                  staticClass: "form-control",
                  class:
                    _vm.ishint && _vm.participant.questions["Q207"].hasError
                      ? "check-red"
                      : "",
                  attrs: {
                    id: "Q207-" + _vm.seq,
                    disabled:
                      _vm.disabledByAttendance ||
                      !_vm.infoAvailable ||
                      _vm.participant.questions["Q201"].raw_data === "DOMESTIC"
                  },
                  domProps: {
                    value: _vm.participant.questions["Q207"].raw_data
                  },
                  on: {
                    change: function($event) {
                      return _vm.inputSelectAnswer(
                        _vm.seq,
                        "Q207",
                        $event.target
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("국가선택")]),
                  _vm._v(" "),
                  _vm._l(_vm.counties, function(country, index) {
                    return [
                      _c(
                        "option",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.participant.questions["Q201"].raw_data !==
                                  "DOMESTIC" &&
                                country.COUNTRY_KOR_NM !== "대한민국",
                              expression:
                                "participant.questions['Q201'].raw_data !== 'DOMESTIC' && country.COUNTRY_KOR_NM !== '대한민국'"
                            }
                          ],
                          key: index,
                          attrs: {
                            checked:
                              _vm.participant.questions["Q207"].raw_data ==
                              country.COUNTRY_KOR_NM
                          },
                          domProps: { value: country.COUNTRY_KOR_NM }
                        },
                        [
                          _vm._v(
                            _vm._s(country.COUNTRY_ISO_WORD3) +
                              " - " +
                              _vm._s(country.COUNTRY_KOR_NM)
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _vm.participant.questions["Q201"].raw_data === "DOMESTIC"
            ? _c(
                "p",
                {
                  staticClass: "marTS fntE",
                  staticStyle: {
                    color: "#d91734",
                    "text-indent": "-0.6em",
                    "padding-left": "0.6em"
                  }
                },
                [_vm._v("* 내국인은 대한민국 자동 선택됩니다.")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.participant.questions["Q201"].raw_data !== "DOMESTIC"
            ? _c(
                "p",
                {
                  staticClass: "marTS fntE",
                  staticStyle: {
                    color: "#d91734",
                    "text-indent": "-0.6em",
                    "padding-left": "0.6em"
                  }
                },
                [
                  _vm.ishint && _vm.participant.questions["Q207"].hasError
                    ? [_vm._v("🚫 국가를 선택해 주세요.")]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM pf23-inFo-common pf23-lineBtm",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_passportnumber-" + _vm.seq }
              },
              [
                _vm._v("여권번호 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.participant.questions["Q208"].hasError &&
                _vm.participant.questions["Q208"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "20",
                id: "Q208-" + _vm.seq,
                name: "NCAcmi_passportnumber" + _vm.seq + "-1",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q208"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputPassportAnswer(_vm.seq, "Q208", $event.target)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_passportfrom" + _vm.seq }
              },
              [
                _vm._v("여권발급일 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.ishint && _vm.participant.questions["Q209"].hasError
                  ? "check-red"
                  : "",
              attrs: {
                type: "date",
                size: "50",
                maxlength: "50",
                id: "Q209-" + _vm.seq,
                name: "NCAcmi_passportfrom" + _vm.seq,
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
                max: _vm.today
              },
              domProps: { value: _vm.participant.questions["Q209"].raw_data },
              on: {
                change: function($event) {
                  return _vm.inputPassportDateAnswer(
                    _vm.seq,
                    "Q209",
                    $event.target
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [
              _vm.ishint && _vm.participant.questions["Q209"].hasError
                ? [
                    _vm._v(
                      "🚫 " +
                        _vm._s(
                          _vm.participant.questions["Q209"].remarks
                            ? _vm.participant.questions["Q209"].remarks
                            : "여권발급일을 선택해주세요."
                        )
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_passportend" + _vm.seq }
              },
              [
                _vm._v("여권만료일 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.ishint && _vm.participant.questions["Q210"].hasError
                  ? "check-red"
                  : "",
              attrs: {
                type: "date",
                size: "50",
                maxlength: "50",
                id: "Q210-" + _vm.seq,
                name: "NCAcmi_passportend" + _vm.seq,
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
                min: _vm.today
              },
              domProps: { value: _vm.participant.questions["Q210"].raw_data },
              on: {
                change: function($event) {
                  _vm.inputPassportDateAnswer(_vm.seq, "Q210", $event.target)
                  _vm.navtiveAlert(
                    "여권 만료일은 출국일로부터 6개월 이상이어야 합니다.\n잔여 유효기간이 6개월 미만인 경우 여권을 재발급 받은 후 담당 여행사 (02-2022-6520)로 연락주시기 바랍니다."
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [
              _vm.ishint && _vm.participant.questions["Q210"].hasError
                ? [
                    _vm._v(
                      "🚫 " +
                        _vm._s(
                          _vm.participant.questions["Q210"].remarks
                            ? _vm.participant.questions["Q210"].remarks
                            : "여권만료일을 선택해주세요."
                        )
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_passportnumber-" + _vm.seq }
              },
              [_vm._v("신장 "), _c("span", { staticClass: "ico-must-astar" })]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.ishint && _vm.participant.questions["Q211"].hasError
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "3",
                placeholder: "cm 단위",
                id: "Q211-" + _vm.seq,
                name: "NCAcmi_passportnumber" + _vm.seq + "-1",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q211"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputNumberAnswer(_vm.seq, "Q211", $event.target)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em",
                height: "21px"
              }
            },
            [
              _vm.ishint && _vm.participant.questions["Q211"].hasError
                ? [_vm._v("\n      🚫 신장을 입력해 주시기 바랍니다.")]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "NCAcmi_passportnumber-" + _vm.seq }
              },
              [_vm._v("체중 "), _c("span", { staticClass: "ico-must-astar" })]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.ishint && _vm.participant.questions["Q212"].hasError
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "3",
                placeholder: "kg 단위",
                id: "Q212-" + _vm.seq,
                name: "NCAcmi_passportnumber" + _vm.seq + "-1",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q212"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputNumberAnswer(_vm.seq, "Q212", $event.target)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em",
                height: "21px"
              }
            },
            [
              _vm.ishint && _vm.participant.questions["Q212"].hasError
                ? [_vm._v("\n      🚫 체중을 입력해 주시기 바랍니다.")]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "Q213-" + _vm.seq }
              },
              [
                _vm._v("신발사이즈 "),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pf23-inFo-select pf23-country" }, [
              _c(
                "select",
                {
                  staticClass: "form-control",
                  class:
                    _vm.ishint && _vm.participant.questions["Q213"].hasError
                      ? "check-red"
                      : "",
                  attrs: {
                    id: "Q213-" + _vm.seq,
                    disabled: _vm.disabledByAttendance || !_vm.infoAvailable
                  },
                  domProps: {
                    value: _vm.participant.questions["Q213"].raw_data
                  },
                  on: {
                    change: function($event) {
                      return _vm.inputSelectAnswer(
                        _vm.seq,
                        "Q213",
                        $event.target
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("사이즈선택")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.shoeSize, function(item, index) {
                    return [
                      _c(
                        "option",
                        {
                          key: index,
                          attrs: {
                            checked:
                              _vm.participant.questions["Q213"].raw_data ==
                              item.CODE
                          },
                          domProps: { value: item.CODE }
                        },
                        [_vm._v(_vm._s(item.LABEL))]
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "marTS fntE",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em",
                height: "21px"
              }
            },
            [_vm._v("* 신발 사이즈 195mm 이하는 스키만 선택이 가능합니다.")]
          ),
          _vm._v(" "),
          _vm.ishint && _vm.participant.questions["Q213"].hasError
            ? _c(
                "p",
                {
                  staticClass: "marTS fntE",
                  staticStyle: {
                    color: "#d91734",
                    "text-indent": "-0.6em",
                    "padding-left": "0.6em"
                  }
                },
                [_vm._v("🚫 신발사이즈를 선택해 주세요.")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM pf23-lineBtm",
          class: _vm.isLeft ? "pf23-inFo-L" : "pf23-inFo-R"
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              class: { moOnly: !_vm.isLeft },
              attrs: { for: "reports-radio-" + _vm.seq }
            },
            [
              _vm._v("스키/보드 "),
              _c("span", { staticClass: "ico-must-astar" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "amway-theme", staticStyle: { width: "55%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                },
                [
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "스키",
                          id: "Q214-" + _vm.seq,
                          name: "reports-radio-" + _vm.seq,
                          disabled:
                            _vm.disabledByAttendance || !_vm.infoAvailable
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q214"].raw_data ===
                            "스키"
                        },
                        on: {
                          change: function($event) {
                            return _vm.inputRadioAnswer(
                              "" + _vm.seq,
                              "Q214",
                              "스키"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("스키")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          value: "보드",
                          name: "reports-radio-" + _vm.seq,
                          disabled:
                            _vm.disabledByAttendance || !_vm.infoAvailable
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q214"].raw_data ===
                            "보드"
                        },
                        on: {
                          change: function($event) {
                            return _vm.inputRadioAnswer(
                              "" + _vm.seq,
                              "Q214",
                              "보드"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("보드")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03",
          class: _vm.isLeft ? "pf23-inFo-C" : "pf23-inFo-C-R"
        },
        [
          _c("div", { staticClass: "pf23-input-wrap-normal" }, [
            _c(
              "label",
              {
                staticClass: "fntP",
                class: { moOnly: !_vm.isLeft },
                attrs: { for: "Q215-" + _vm.seq }
              },
              [
                _vm._v("스키/보드 레벨"),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pf23-inFo-select pf23-country" }, [
              _c(
                "select",
                {
                  staticClass: "form-control",
                  class:
                    _vm.ishint && _vm.participant.questions["Q215"].hasError
                      ? "check-red"
                      : "",
                  attrs: {
                    id: "Q215-" + _vm.seq,
                    disabled:
                      _vm.disabledByAttendance ||
                      !_vm.infoAvailable ||
                      _vm.participant.questions["Q215"].raw_data === "DOMESTIC"
                  },
                  domProps: {
                    value: _vm.participant.questions["Q215"].raw_data
                  },
                  on: {
                    change: function($event) {
                      return _vm.inputSelectAnswer(
                        _vm.seq,
                        "Q215",
                        $event.target
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("레벨선택")]),
                  _vm._v(" "),
                  _vm._l(_vm.sportLevel, function(item, index) {
                    return [
                      _c(
                        "option",
                        {
                          key: index,
                          attrs: {
                            checked:
                              _vm.participant.questions["Q215"].raw_data ==
                              item.CODE
                          },
                          domProps: { value: item.CODE }
                        },
                        [_vm._v(_vm._s(item.LABEL))]
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _vm.ishint && _vm.participant.questions["Q215"].hasError
            ? _c(
                "p",
                {
                  staticClass: "marTS fntE",
                  staticStyle: {
                    color: "#d91734",
                    "text-indent": "-0.6em",
                    "padding-left": "0.6em"
                  }
                },
                [_vm._v("🚫 레벨을 선택해 주세요.")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("SurveyAttachment", {
        staticClass: "padBSM padTSM pf23-lineBtm",
        class: {
          NCAcmi_last:
            _vm.participant.type === "S" ||
            (_vm.participant.type === "P" && _vm.hideDocument)
        },
        attrs: {
          id: "Q220-" + _vm.seq,
          participant: _vm.participant,
          "sq-code": "Q220",
          disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
          "is-left": _vm.isLeft
        }
      }),
      _vm._v(" "),
      _c("SurveyAttachmentCommon", {
        staticClass: "padBSM padTSM pf23-lineBtm",
        class: { NCAcmi_blankR: _vm.hideDocument },
        attrs: {
          id: "Q221-" + _vm.seq,
          participant: _vm.participant,
          "sq-code": "Q221",
          disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
          "is-left": _vm.isLeft,
          "hide-btn": _vm.hideDocument,
          height: _vm.hideDocument ? null : "121px",
          "display-right": _vm.hideDocument
        }
      }),
      _vm._v(" "),
      _c("SurveyAttachmentCommon", {
        staticClass: "padBSM padTSM pf23-lineBtm",
        class: { NCAcmi_blankR: _vm.hideDocument },
        attrs: {
          id: "Q222-" + _vm.seq,
          participant: _vm.participant,
          "sq-code": "Q222",
          disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
          "is-left": _vm.isLeft,
          "hide-btn": _vm.hideDocument,
          height: _vm.hideDocument ? null : "121px",
          "display-right": _vm.hideDocument
        }
      }),
      _vm._v(" "),
      _vm.existSpouse
        ? _c("SurveyAttachmentCommon", {
            staticClass: "padBSM padTSM pf23-lineBtm",
            class: { NCAcmi_blankR: _vm.hideDocument },
            attrs: {
              id: "Q224-" + _vm.seq,
              participant: _vm.participant,
              "sq-code": "Q224",
              "hide-btn": !_vm.hideDocument,
              disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
              "is-left": _vm.isLeft,
              height: _vm.hideDocument ? null : "121px",
              "display-right": _vm.isLeft
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.needFamilyRelationDocument
        ? _c("SurveyAttachmentCommon", {
            staticClass: "padBSM padTSM pf23-lineBtm",
            class: { NCAcmi_blankR: _vm.hideDocument },
            attrs: {
              id: "Q225-" + _vm.seq,
              participant: _vm.participant,
              "sq-code": "Q225",
              "hide-btn": _vm.hideDocument,
              disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
              "is-left": _vm.isLeft,
              height: _vm.hideDocument ? null : "198.19px",
              "display-right": _vm.hideDocument
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "outer",
                  fn: function() {
                    return [
                      !_vm.hideDocument && _vm.isLeft
                        ? _c("p", {
                            staticClass: "marTS fntE",
                            staticStyle: {
                              color: "#0075a4",
                              "padding-left": "0.6em"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.questions["Q225"].alert_text
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hideDocument && !_vm.isLeft
                        ? _c("p", {
                            staticClass: "marTS fntE",
                            staticStyle: {
                              color: "#0075a4",
                              "padding-left": "0.6em"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.questions["Q225"].alert_text
                              )
                            }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1390010661
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLeft
        ? _c("div", { staticClass: "padTSM moOnly pf23-lineBtm" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("p", { staticClass: "fntP padTSM" }, [
              _vm._v(
                "‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pf23-inFo-safe-L marTSM" }, [
              _c(
                "div",
                { staticClass: "amway-theme", staticStyle: { width: "55%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "amw-radio-wrap radio-label focus" },
                        [
                          _c("input", {
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio01-4",
                              value: "Y",
                              id: "Q217-" + _vm.seq + "-FO",
                              disabled:
                                !_vm.participant.attendance_yn ||
                                _vm.participant.attendance_yn === "N" ||
                                !_vm.infoAvailable
                            },
                            domProps: {
                              checked:
                                _vm.participant.questions["Q217"].raw_data ===
                                "Y"
                            },
                            on: {
                              change: function($event) {
                                return _vm.inputRadioAnswer(
                                  "" + _vm.seq,
                                  "Q217",
                                  "Y"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("예")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "amw-radio-wrap radio-label focus",
                          staticStyle: { "margin-right": "1.5em" }
                        },
                        [
                          _c("input", {
                            staticClass: "amw-global-radio",
                            attrs: {
                              type: "radio",
                              name: "radio01-4",
                              value: "N",
                              disabled:
                                !_vm.participant.attendance_yn ||
                                _vm.participant.attendance_yn === "N" ||
                                !_vm.infoAvailable
                            },
                            domProps: {
                              checked:
                                _vm.participant.questions["Q217"].raw_data ===
                                "N"
                            },
                            on: {
                              change: function($event) {
                                return _vm.inputRadioAnswer(
                                  "" + _vm.seq,
                                  "Q217",
                                  "N"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-radio-overlay" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "amw-label-radio-text" }, [
                            _vm._v("아니오")
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "marTS fntE",
                staticStyle: {
                  color: "#0075a4",
                  "text-indent": "-0.6em",
                  "padding-left": "0.6em"
                }
              },
              [
                _vm._v(
                  "* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에\n      작성하여 주시기 바랍니다."
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("안전 확인"),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b176341", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b176341","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sapporo/components/SurveyParticipant.vue
// module id = null
// module chunks = 